import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import React from 'react';
import { useForm } from 'react-hook-form';
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton, MyMSearchButton } from '../../ui-elements/MyMButton';
import { MyMDropDownList } from '../../ui-elements/MyMDropDownList';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import ValidatableDatePicker from '../../ui-parts/ValidatableDatePicker';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';
import dayjs from 'dayjs';

export const FileManagementSearchCondition = React.memo((props) => {
  const { formState, control, handleSubmit, reset } = useForm({
    mode: 'onSubmit',
  })
  const validationRules = useValidationRules();
  const {
    screenId,
    searchCondition,
    searchInputCondition,
    setSearchInputCondition,
    setPageNumber,
    setSortModel,
    setIsSearch
  } = props
  const { controlSettings, messageList } = useWebContext(screenId);

  const handleForm = e => {
    setSearchInputCondition({
      ...searchInputCondition,
      [e.target.name]: e.target.value
    });
  }

  /** 検索クリック時処理 */
  const handleSearch = () => {
    // ページ番号・ソート情報をリセットし、useEffectフックで検索実施
    setIsSearch(true);
    setPageNumber(1);
    setSortModel([]);
  }

  /** クリアクリック時処理 */
  const handleClear = () => {
    reset();
    setSearchInputCondition({
      FileName: "",
      UploadBy: "",
      UploadDateFrom: null,
      UploadDateTo: null,
      Model: "",
      ProductType: "",
      BusinessArea: "",
    });
  };

  const dropdownDefaultProps = {
    sx: { minWidth: '45%' },
    width: "200px",
    needsBlank: true,
    onChange: handleForm,
  }

  const conditionControlList = [
    {
      lg: 3.5,
      label: controlSettings.LabelList.lblFileNameLabel,
      control:
        <ValidatableTextBox
          control={control}
          name="FileName"
          defaultValue={searchInputCondition.FileName}
          formState={formState}
          maxLength={300}
          rules={{
            ...validationRules.maxLength(300),
          }}
          onBlur={e => handleForm(e)}
        />
    },
    {
      lg: 2.5,
      label: controlSettings.LabelList.lblUploadbyLabel,
      control: <MyMDropDownList {...dropdownDefaultProps} options={searchCondition.UploadByList} name="UploadBy" value={searchInputCondition.UploadBy} />
    },
    {
      md: 12,
      lg: 6,
      label: controlSettings.LabelList.lblUploadDateLabel,
      control:
        <>
          {/* 2026.6.9 ブラウザ言語による日付選択時のエラー対応 Modify Start */}
          <ValidatableDatePicker
            name="UploadDateFrom"
            onChange={
              (newValue) => setSearchInputCondition({ ...searchInputCondition, "UploadDateFrom": newValue !== null ? newValue.format('YYYY/MM/DD') : null })
            }
            width="300px"
            value={searchInputCondition.UploadDateFrom ? dayjs(searchInputCondition.UploadDateFrom) : null}
            control={control}
            formState={formState}
            rules={{
              ...validationRules.date("UploadDateFrom"),
            }}
          />
          {/* 2026.6.9 ブラウザ言語による日付選択時のエラー対応 Modify End */}
          <MyMLabel sx={{ lineHeight: "40px", padding: "0 15px" }}>~</MyMLabel>
          {/* 2026.6.9 ブラウザ言語による日付選択時のエラー対応 Modify Start */}
          <ValidatableDatePicker
            name="UploadDateTo"
            onChange={
              (newValue) => setSearchInputCondition({ ...searchInputCondition, "UploadDateTo": newValue !== null ? newValue.format('YYYY/MM/DD') : null })
            }
            width="300px"
            value={searchInputCondition.UploadDateTo ? dayjs(searchInputCondition.UploadDateTo) : null}
            control={control}
            formState={formState}
            rules={{
              ...validationRules.date("UploadDateTo"),
            }}
          />
          {/* 2026.6.9 ブラウザ言語による日付選択時のエラー対応 Modify End */}
        </>
    },
    {
      lg: 3.5,
      label: controlSettings.LabelList.lblMetadataProductTypeLabel,
      control: <MyMDropDownList {...dropdownDefaultProps} options={searchCondition.ProductTypeList} name="ProductType" value={searchInputCondition.ProductType} />
    },
    {
      lg: 2.5,
      label: controlSettings.LabelList.lblMetadataBusinessAreaLabel,
      control: <MyMDropDownList {...dropdownDefaultProps} options={searchCondition.BusinessAreaList} name="BusinessArea" value={searchInputCondition.BusinessArea} />
    },
  ];

  const onError = () => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  return (
    <Box sx={{ borderBottom: "3px solid #333", padding: "15px 20px", margin: "0px 20px" }}>
      <MyMVariantLabel variant="h6">{controlSettings.LabelList.lblFileManagement}</MyMVariantLabel>
      <form>
        <Grid container className='pt-2'>
          <Grid item xs={10}>
            <Grid container columnSpacing={5}>
              {conditionControlList.map((x, i) => {
                return (
                  <Grid item xs={12} md={x.md ?? 6} lg={x.lg} className='d-flex pb-2' key={i} sx={{ marginBottom: "7px" }}>
                    <MyMLabel sx={{ minWidth: 120, lineHeight: "40px" }}>
                      {x.label}
                    </MyMLabel>
                    {x.control}
                  </Grid>
                )
              })}
            </Grid>
          </Grid>
          <Grid item xs={2} className='d-flex align-items-end justify-content-end pb-2'>
            <Stack direction='row' marginRight='1rem' spacing={3}>
              <MyMSearchButton handleSearch={handleSubmit(handleSearch, onError)} searchText={controlSettings.LabelList.btnSearch} />
              <MyMButton onClick={handleClear}>Clear</MyMButton>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </Box >
  )
}
)
